import { ChevronDown } from "@repo/ui";
import { cn } from "@repo/utils";
import type { Brand } from "~/types/api";

type Props = {
  brand: Brand;
  isExpanded: boolean;
  isLoading: boolean;
  activeCount: number;
  totalCount: number;
  onToggle: () => void;
  onHover: () => void;
};

export const BrandRowHeader = ({
  brand,
  isExpanded,
  isLoading,
  activeCount,
  totalCount,
  onToggle,
  onHover,
}: Props) => (
  <button
    onClick={onToggle}
    onMouseEnter={onHover}
    className="flex w-full cursor-pointer items-center gap-3 px-6 py-4 text-left transition-colors hover:bg-gray-50"
  >
    <ChevronDown
      className={cn(
        "h-5 w-5 text-gray-500 transition-transform",
        isExpanded ? "rotate-0" : "-rotate-90"
      )}
    />

    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-600 font-semibold text-white">
      {brand.name.charAt(0).toUpperCase()}
    </div>

    <div className="flex-1">
      <h3 className="text-lg font-semibold text-gray-900">{brand.name}</h3>
      {isExpanded && !isLoading && (
        <p className="text-sm text-gray-500">
          {activeCount} active {activeCount === 1 ? "task" : "tasks"} • {totalCount} total
        </p>
      )}
    </div>
  </button>
);
